import { Box, Button } from "@mui/material";
import {
  ModalProps,
  createUseModal,
  useFormModal,
} from "@imminently/react/context/modals";
import { Text } from "@imminently/react/ui/core/text";

import { HighriskIcon } from "@/assets/icons";
import MultilineTextInput from "@/components/MultilineTextInput";
import PatientCardModal from "@/components/PatientCardModal";
import { PatientEncounter } from "@/resources/types";
import { encounterService } from "@/services";
import { css } from "@/theme";

const { useUpdate } = encounterService;

const styles = {
  headIcon: css`
    text-align: center;
    display: block;
  `,
  underIcon: css`
    text-align: center;
    display: block;
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding: 0 4.5rem;
  `,
};

interface ArchivePatientModalProps {
  encounter: PatientEncounter;
}

const ArchivePatientModal = ({ props }: ModalProps<ArchivePatientModalProps>) => {
  const { encounter } = props;

  const { mutateAsync, isLoading } = useUpdate();
  const { methods, notify, close } = useFormModal({
    mode: "all",
    defaultValues: {
      note: "",
    },
  });

  const { control, handleSubmit, formState } = methods;

  const submit = (data: any) => {
    const note = { text: data.note };
    // to-do status archived, currently disabled
    mutateAsync({
      id: encounter.id,
      payload: { status: "disabled", note },
    }).catch(() => {
      notify.error("Failed to discharge patient");
    });

    close(true);
  };

  return (
    <PatientCardModal
      title="Archive Patient Record"
      encounter={encounter}
      onClose={() => close()}
    >
      <Box display="flex" alignItems="center" css={styles.headIcon}>
        <HighriskIcon />
      </Box>
      <Box css={styles.underIcon}>
        <Text variant="h4">
          Are you sure you want to archive the following patient record?
        </Text>
      </Box>

      <MultilineTextInput
        control={control}
        field="note"
        required
        label="Reason for archive..."
        rows={3}
      />

      <Button
        sx={{ ml: "auto" }}
        disabled={isLoading || !formState.isValid}
        onClick={handleSubmit(submit)}
      >
        Yes, archive
      </Button>
    </PatientCardModal>
  );
};

export const useArchivePatientModal = createUseModal(ArchivePatientModal);
